import script from "./DeliveryIssues.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryIssues.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryIssues.vue?vue&type=style&index=0&id=4b40bab9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b40bab9"]])

export default __exports__